<template>
  <div class="funnel-item">
    <div class="investor-logo">
      <div
        v-show="investor.logo_url"
        class="img-cropped centered"
        :style="{ 'background-image': `url(${investor.logo_url})` }"
      />
      <img-placeholder
        v-show="!investor.logo_url"
        class="img-responsive centered"
        width="50"
        height="50"
      />
    </div>
    <div class="investor-data">
      <a href @click.prevent="openInvestorModal(investor)">
        {{ investor.name | trim }}
      </a>
      <span>{{ investor.country | countryName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    investor: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    openInvestorModal(investor) {
      this.$emit('open-investor-modal', investor)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';
.funnel-item {
  font-size: 14px;
  font-weight: 100;
  margin: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 2px $grey90;
  height: 60px;
  min-width: 218px;

  .investor-data {
    color: $grey90;
    margin-left: 10px;
    display: flex;
    flex-direction: column;

    a {
      font-size: 16px;
      color: $grey60;
    }
    a:hover {
      color: $yellow;
      text-decoration: none;
    }
  }

  .investor-logo {
    width: 50px;
    height: 50px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 50%;
    box-shadow: 0 0 1px $grey90;

    .img-cropped {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      width: 50px;
      height: 50px;
      -webkit-border-radius: 25px;
      -moz-border-radius: 25px;
      border-radius: 50%;
    }
  }
}
</style>
